// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Input dimensions: 463x118 at 1536x864 screen
 * 463 / 1536 = 30.14vw width
 * 118px total height includes label + input
 */
.register-textbox_input-wrapper__dCpAt {
  position: relative;
  display: flex;
  align-items: center;
  /* 463 / 1536 = 30.14vw */
  width: 30.14vw;
  max-width: 463px;
  min-width: 200px;
}

.register-textbox_textbox__9uJoG {
  width: 100%;
  /* Larger padding for bigger input - roughly 50-55px height */
  padding: clamp(14px, 1.8vh, 20px) clamp(18px, 1.8vw, 28px);
  border: none;
  border-radius: 50px;
  background: linear-gradient(270deg, #CFE5FF 0%, #FFE5B0 100%);
  color: black;
  font-size: clamp(15px, 1.3vw, 20px);
}

.register-textbox_textbox__9uJoG:focus {
  outline: none;
  box-shadow: 0 0 4px 1px #FFE5B0;
}

.register-textbox_textbox__9uJoG::placeholder {
  color: #9a9a9a;
  opacity: 1;
}

.register-textbox_label__bA-lb {
  display: block;
  margin-bottom: 6px;
  margin-left: 20px;
  margin-top: 0;
  font-family: "FreckleFace", serif;
  font-weight: 400;
  font-style: normal;
  color: #FEE5B1;
  font-size: clamp(16px, 1.4vw, 22px);
}

.register-textbox_label-wrapper__vHGwb {
  /* Match input wrapper width */
  width: 30.14vw;
  max-width: 463px;
  min-width: 200px;
  display: inline-block;
  border: none;
  background: none;
  text-align: left;
}

.register-textbox_icon-wrapper__3IbsT {
  position: absolute;
  right: 16px;
  cursor: pointer;
  font-size: 1.2rem;
  color: #666;
}

.register-textbox_icon-wrapper__3IbsT:hover {
  color: #000;
}

.register-textbox_error-text__GReLp {
  color: #ff0000;
  font-size: clamp(0.7rem, 0.9vw, 0.85rem);
  margin: 0;
  margin-top: 4px;
  margin-left: 16px;
}

/* Tablet adjustments */
@media (max-width: 1024px) {

  .register-textbox_input-wrapper__dCpAt,
  .register-textbox_label-wrapper__vHGwb {
    width: 40vw;
    max-width: 350px;
  }

  .register-textbox_textbox__9uJoG {
    padding: 14px 18px;
    font-size: 16px;
  }

  .register-textbox_label__bA-lb {
    font-size: 16px;
    margin-left: 16px;
  }
}

/* Mobile adjustments */
@media (max-width: 768px) {

  .register-textbox_input-wrapper__dCpAt,
  .register-textbox_label-wrapper__vHGwb {
    width: 100%;
    max-width: 100%;
  }

  .register-textbox_textbox__9uJoG {
    width: 100%;
    padding: 14px 18px;
    font-size: 15px;
  }

  .register-textbox_label__bA-lb {
    font-size: 15px;
    margin-left: 14px;
  }
}`, "",{"version":3,"sources":["webpack://./src/UI/common/Inputs/register-textbox.module.css"],"names":[],"mappings":"AAAA;;;EAGE;AACF;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,6DAA6D;EAC7D,0DAA0D;EAC1D,YAAY;EACZ,mBAAmB;EACnB,6DAA6D;EAC7D,YAAY;EACZ,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,+BAA+B;AACjC;;AAEA;EACE,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;EACb,iCAAiC;EACjC,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,mCAAmC;AACrC;;AAEA;EACE,8BAA8B;EAC9B,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;EACrB,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;EACd,wCAAwC;EACxC,SAAS;EACT,eAAe;EACf,iBAAiB;AACnB;;AAEA,uBAAuB;AACvB;;EAEE;;IAEE,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;AACF;;AAEA,uBAAuB;AACvB;;EAEE;;IAEE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;AACF","sourcesContent":["/* Input dimensions: 463x118 at 1536x864 screen\n * 463 / 1536 = 30.14vw width\n * 118px total height includes label + input\n */\n.input-wrapper {\n  position: relative;\n  display: flex;\n  align-items: center;\n  /* 463 / 1536 = 30.14vw */\n  width: 30.14vw;\n  max-width: 463px;\n  min-width: 200px;\n}\n\n.textbox {\n  width: 100%;\n  /* Larger padding for bigger input - roughly 50-55px height */\n  padding: clamp(14px, 1.8vh, 20px) clamp(18px, 1.8vw, 28px);\n  border: none;\n  border-radius: 50px;\n  background: linear-gradient(270deg, #CFE5FF 0%, #FFE5B0 100%);\n  color: black;\n  font-size: clamp(15px, 1.3vw, 20px);\n}\n\n.textbox:focus {\n  outline: none;\n  box-shadow: 0 0 4px 1px #FFE5B0;\n}\n\n.textbox::placeholder {\n  color: #9a9a9a;\n  opacity: 1;\n}\n\n.label {\n  display: block;\n  margin-bottom: 6px;\n  margin-left: 20px;\n  margin-top: 0;\n  font-family: \"FreckleFace\", serif;\n  font-weight: 400;\n  font-style: normal;\n  color: #FEE5B1;\n  font-size: clamp(16px, 1.4vw, 22px);\n}\n\n.label-wrapper {\n  /* Match input wrapper width */\n  width: 30.14vw;\n  max-width: 463px;\n  min-width: 200px;\n  display: inline-block;\n  border: none;\n  background: none;\n  text-align: left;\n}\n\n.icon-wrapper {\n  position: absolute;\n  right: 16px;\n  cursor: pointer;\n  font-size: 1.2rem;\n  color: #666;\n}\n\n.icon-wrapper:hover {\n  color: #000;\n}\n\n.error-text {\n  color: #ff0000;\n  font-size: clamp(0.7rem, 0.9vw, 0.85rem);\n  margin: 0;\n  margin-top: 4px;\n  margin-left: 16px;\n}\n\n/* Tablet adjustments */\n@media (max-width: 1024px) {\n\n  .input-wrapper,\n  .label-wrapper {\n    width: 40vw;\n    max-width: 350px;\n  }\n\n  .textbox {\n    padding: 14px 18px;\n    font-size: 16px;\n  }\n\n  .label {\n    font-size: 16px;\n    margin-left: 16px;\n  }\n}\n\n/* Mobile adjustments */\n@media (max-width: 768px) {\n\n  .input-wrapper,\n  .label-wrapper {\n    width: 100%;\n    max-width: 100%;\n  }\n\n  .textbox {\n    width: 100%;\n    padding: 14px 18px;\n    font-size: 15px;\n  }\n\n  .label {\n    font-size: 15px;\n    margin-left: 14px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"input-wrapper": `register-textbox_input-wrapper__dCpAt`,
	"textbox": `register-textbox_textbox__9uJoG`,
	"label": `register-textbox_label__bA-lb`,
	"label-wrapper": `register-textbox_label-wrapper__vHGwb`,
	"icon-wrapper": `register-textbox_icon-wrapper__3IbsT`,
	"error-text": `register-textbox_error-text__GReLp`
};
export default ___CSS_LOADER_EXPORT___;
